/* tslint:disable */
/* eslint-disable */
/**
 * Carrot Config Service API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.2.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * The "LanguageType" Enum
 * @export
 */
export const LanguageType = {
    En: 'en',
    Nb: 'nb'
};
export function instanceOfLanguageType(value) {
    for (const key in LanguageType) {
        if (Object.prototype.hasOwnProperty.call(LanguageType, key)) {
            if (LanguageType[key] === value) {
                return true;
            }
        }
    }
    return false;
}
export function LanguageTypeFromJSON(json) {
    return LanguageTypeFromJSONTyped(json, false);
}
export function LanguageTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function LanguageTypeToJSON(value) {
    return value;
}
//# sourceMappingURL=LanguageType.js.map